/**
 * Generates a truncated string snippet from the given response data.
 *
 * @remarks
 * Useful for logging large data structures without overwhelming the console.
 *
 * @param data - to to convert to a "snippet"
 * @returns A short string (max 30 chars) describing `data`
 */
export function getDebugSnippet(data: unknown): string {
    try {
        if (Array.isArray(data)) {
            return JSON.stringify(data);
        }
        if (typeof data === 'string') {
            return data.slice(0, 30);
        }
        if (typeof data === 'object') {
            return JSON.stringify(data).slice(0, 30);
        }
        // Fallback for numbers, booleans, null, undefined, etc.
        return String(data).slice(0, 30);
    } catch (error) {
        return '[Error creating debug snippet]';
    }
}
